'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _get2 = require('babel-runtime/helpers/get');

var _get3 = _interopRequireDefault(_get2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _component = require('@loadable/component');

var _component2 = _interopRequireDefault(_component);

var _lodash = require('lodash');

var _lodash2 = _interopRequireDefault(_lodash);

var _IDTextbox2 = require('./IDTextbox');

var _IDTextbox3 = _interopRequireDefault(_IDTextbox2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// import '../lib/cleave/addon/cleave-phone.vi';
// import '../lib/cleave/addon/cleave-phone.vn';


var PhoneVi = _component2.default.lib(function () {
    return import("../lib/cleave/addon/cleave-phone.vi");
});
var PhoneVn = _component2.default.lib(function () {
    return import("../lib/cleave/addon/cleave-phone.vn");
});

var IDPhone = function (_IDTextbox) {
    (0, _inherits3.default)(IDPhone, _IDTextbox);

    function IDPhone() {
        var _ref;

        var _temp, _this, _ret;

        (0, _classCallCheck3.default)(this, IDPhone);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = IDPhone.__proto__ || (0, _getPrototypeOf2.default)(IDPhone)).call.apply(_ref, [this].concat(args))), _this), _this.dataTestID = 'phone', _this.inputType = 'phone', _this.renderCleavePhone = function () {
            return _react2.default.createElement(
                _react2.default.Fragment,
                null,
                _react2.default.createElement(PhoneVn, null),
                _react2.default.createElement(PhoneVi, null)
            );
        }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
    }

    (0, _createClass3.default)(IDPhone, [{
        key: 'setValue',
        value: function setValue(value) {
            var _this2 = this;

            var withCountryCode = this.props.withCountryCode;

            this.tooglePlaceholder(value);

            this.setState({ value: value }, function () {
                if (withCountryCode) {
                    _this2.props.onChange && _this2.props.onChange('' + (_this2.state.countryCode || _this2.props.defaultCountryCode) + value.replace(/^0+/, ''));
                } else {
                    _this2.props.onChange && _this2.props.onChange(value);
                }
            });
        }
    }, {
        key: 'renderPlaceholder',
        value: function renderPlaceholder() {
            var _props = this.props,
                options = _props.options,
                withCountryCode = _props.withCountryCode,
                countryCodeWidth = _props.countryCodeWidth;

            if (_lodash2.default.get(options, 'prefix')) {
                return null;
            }
            return (0, _get3.default)(IDPhone.prototype.__proto__ || (0, _getPrototypeOf2.default)(IDPhone.prototype), 'renderPlaceholder', this).call(this, null, null, withCountryCode && { left: countryCodeWidth });
        }
    }]);
    return IDPhone;
}(_IDTextbox3.default);

exports.default = IDPhone;


IDPhone.defaultProps = (0, _extends3.default)({}, _IDTextbox3.default.defaultProps, {
    type: "cleave",
    iconType: 'phone',
    options: {
        prefix: ""
    },
    defaultCountryCode: '+1'
});